import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Constants } from "../../../../core/services/constants.service";
import { HttpService } from "../../../../core";
import { environment } from "../../../../../environments/environment";
import { ToastrService } from "ngx-toastr";
import { ProjectService } from "../../../../core/services/project.service";
import $ from "jquery";
import { MatDialog } from "@angular/material/dialog";
import { PhotoDialogComponent } from "../../project-detail/photo-dialog/photo-dialog.component";
import { ActivatedRoute, Router } from "@angular/router";
import { EchartService } from '../../../../core/services/echart.service';

@Component({
  selector: "app-pictures",
  templateUrl: "./pictures.component.html",
  styleUrls: ["./pictures.component.scss"],
})
export class PicturesComponent implements OnInit {
  @Input() isPackage: any;

  @Input() project: any;

  @Output() load = new EventEmitter();
  mode: any;
  images = [];
  logo = [];
  galleryImages = [];

  galleryImageForm: FormGroup;
  logoImageForm: FormGroup;
  isLoading: boolean = true;
  SERVER_URL = environment.SERVER_URL;

  isLogoTooLarge: boolean;
  isGalleryImageTooLarge: boolean;
  noLogoSelected: boolean;
  hasLogo: boolean;
  projectId: string;
  isLogoUploading: boolean;
  isGalleryImageUploading: boolean;

  logoUrl = "";

  indexes = [];
  @Output() uploadPic = new EventEmitter();

  constructor(
    private httpService: HttpService,
    private projectService: ProjectService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private router: Router,
  ) {
    // this.picturesForm = new FormGroup({
    //   file: new FormControl('', [Validators.required]),
    //   fileSource: new FormControl('', [Validators.required])
    // });
    this.projectId = this.route.snapshot.paramMap.get("id");
    this.logoImageForm = this.fb.group({
      logo: [],
    });
    this.galleryImageForm = this.fb.group({
      gallery: [],
    });


    // this.project.images.sort(this.comparePosition);
  }

  ngOnInit(): void {
    this.mode = "manage";
    this.indexes = []
    const project = this.projectId ? this.projectId : this.project.id;
    this.httpService
      .getProjectDetailByProjectId(project)
      .toPromise()
      .then((projectDetail: any) => {

        this.project = projectDetail.data;
        this.project.images.sort(this.comparePosition);
        for (let i = 1; i <= this.project.images.length; i++) {
          this.indexes.push(i);
        }
        this.isLoading = false
      });

    // this.project.images.sort(this.comparePosition);

    // if (this.project.logo && this.project.logo.fileName) {
    //   this.logoUrl = encodeURI(this.SERVER_URL + 'images/' + this.project.projectCode + '/images/' + this.project.logo.fileName);
    // }
  }

  onLogoChange(event) {
    if (event.target.files && event.target.files[0]) {
      // const filesAmount = event.target.files.length;
      if (event.target.files[0].size > Constants.UPLOAD_IMAGE_SIZE) {
        this.isLogoTooLarge = true;
        return;
      } else {
        this.isLogoTooLarge = false;
        this.logo.push(event.target.files[0]);
      }
    }
    this.uploadProjectLogo();
  }

  uploadProjectLogo() {
    const that = this
    if (that.logo.length === 0) {
      that.noLogoSelected = true;
      return;
    }

    // if (that.project.logo) {
    //   that.hasLogo = true;
    //   return;
    // }
    that.isLogoUploading = true;
    const fd = new FormData();
    fd.append("logo", that.logo[0]);
    that.httpService
      .uploadProjectLogo(that.project.id, fd)
      .subscribe((res: any) => {
        if (res.code === 1) {
          // that.project.logo.fileName = res.data.fileName;
          // that.logo = [];
          // that.projectService.projects = null;
          // that.logoImageForm.reset();
          that.logo = []
          that.logoImageForm.reset();
          that.isLoading = true
          that.ngOnInit()



          that.toastrService.success("Project logo has been uploaded.");
          that.isLogoUploading = false;
        } else {
          that.toastrService.error("Failed to upload project logo.");
          that.isLogoUploading = false;
        }
      });
  }

  deleteLogo() {
    this.httpService
      .deleteProjectLogo(this.project.id)
      .subscribe((res: any) => {
        if (res.code === 1) {
          this.project.logo = null;
          this.projectService.projects = null;
          this.toastrService.success("Project logo has been deleted.");
          this.hasLogo = false;
        } else {
          this.toastrService.error("Failed to delete project logo.");
        }
      });
  }

  // onFeatureImageChange(event) {
  //   if (event.target.files && event.target.files[0]) {
  //     const filesAmount = event.target.files.length;
  //     for (let i = 0; i < Constants.UPLOAD_IMAGE_SIZE; i++) {
  //
  //     }
  //   }
  // }

  onGalleryImageChange(event) {
    if (this.project.images.length > 99) {
      this.toastrService.error("The number of pictures cannot exceed 100");
      return;
    }
    this.isGalleryImageTooLarge = false;
    this.galleryImages = [];
    if (event.target.files && event.target.files[0]) {
      const filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        if (event.target.files[i].size < 5242880) {
          this.galleryImages.push(event.target.files[i]);
          this.isGalleryImageTooLarge = this.isGalleryImageTooLarge || false;
        } else {
          this.isGalleryImageTooLarge = this.isGalleryImageTooLarge || true;
        }
      }
      this.uploadGalleryImage();
    }
  }

  uploadGalleryImage() {
    this.isGalleryImageUploading = true;
    const fd = new FormData();
    this.galleryImages.forEach((image) => {
      fd.append("files", image);
    });
    this.httpService
      .uploadGalleryImage(fd, this.project.id)
      .subscribe((res: any) => {
        if (res.code === 1) {
          this.isLoading = true
          this.toastrService.success("Gallery image uploading successful");
          this.ngOnInit();
          // this.project.images = [...res.data];
          this.galleryImages = [];
          this.galleryImageForm.reset();
          this.isGalleryImageUploading = false;
        } else if (res.code === 0) {
          this.isGalleryImageUploading = false;
          this.toastrService.error("Failed to upload gallery image");
        }
      });
  }

  deleteGalleryImage(imageId) {
    // const fd = new FormData();
    // const imageIdArray = imageId;
    // fd.append('imageIds []', JSON.stringify(imageIdArray));
    this.httpService
      .deleteGalleryImage(imageId, this.project.id)
      .subscribe((res: any) => {
        if (res.code === 1) {
          this.uploadPic.emit({ value: true, });
          this.project.images = this.project.images.filter((image) => {
            return image.id !== imageId;
          });

          this.toastrService.success("One image has been deleted.");
        } else if (res.code === 0) {
          this.toastrService.error("Failed to delete this image.");
        }
      });
  }

  encodeURI(url) {
    return encodeURI(url);
  }
  //
  // drop(event: CdkDragDrop<string[]>) {
  //   moveItemInArray(this.project.images, event.previousIndex, event.currentIndex);
  // }

  positionChanged(e, image) {
    if (image.notes && image.notes.pos) {
      image.notes.pos = e.value;
    } else {
      image.pos = e.value;
    }
  }

  changeImagePosition(image) {
    if (!image.pos && !image.notes.pos) {
      return;
    }
    image.isChangingPosition = true;
    const fd = new FormData();
    fd.append("id", image.id);
    fd.append("projectId", this.project.id);
    fd.append(
      "notes",
      JSON.stringify({
        pos: (image.notes && image.notes.pos) || image.pos,
      })
    );

    this.httpService.editGalleryImage(fd).subscribe((res: any) => {
      console.log(res, this.load, 888);
      image.isChangingPosition = false;
      if (res.code === 1) {
        this.project.images.sort(this.comparePosition);
        this.load.emit();
        this.toastrService.success("Image sequence updated.");
      } else {
        this.toastrService.error("Failed to update image sequence.");
      }
    });
  }

  comparePosition(a, b) {
    const positionA = (a.notes && a.notes.pos) || a.pos;
    const positionB = (b.notes && b.notes.pos) || b.pos;

    let comparison = 0;
    if (positionA > positionB) {
      comparison = 1;
    } else if (positionA < positionB) {
      comparison = -1;
    }
    return comparison;
  }

  chooseImage() {

    $("#img-upload").click();
  }

  viewMore() {
    const dialogRef = this.dialog.open(PhotoDialogComponent, {
      maxWidth: "100vw",
      maxHeight: "100vh",
      height: "100%",
      width: "100%",
      data: { project: this.project },
    });
  }
}
